module.exports = __webpack_public_path__ + "img/lock.b5ed6bdb.svg";